module.exports = '4.12.3';



// WEBPACK FOOTER //
// ./src/version.js